/// <reference path="../../../node_modules/@ms/office-online-strings/en-US/transcription-strings.d.ts" />
import Dispatcher from '../dispatcher';
import { LoadingActionTypes } from './LoadingActions';
import { TranscribingActionTypes } from './TranscribingActions';
import { TranscriptionRoutePathNames } from '../routes';
import { RecordingActionTypes } from './RecordingActions';
import { LogError } from '../../utils/ErrorTelemetry';
import { LogEventNames } from '../../backend/interfaces/ITelemetryLogger';
import { LogEvents } from '../../utils/LogEvents';
import { RenderToPaneKeys } from '../pages/telemetry/RenderToPaneKeys';
import { DurationMeasureType } from '../../backend/interfaces/ILogEvent';
import { ErrorStringFromException } from '../../utils/utils';

export enum FailureContinuation {
  None, // Failure can't be continued by user.
  Retry, // Failure can be retried.
  StartOver // Failure can be started over.
}

export const FailureActionTypes = {
  SetFailureContinuationAction: "FAILURE_SET_CONTINUATION_ACTION",
  SetFailureReasonAction: "FAILURE_SET_FAILURE_REASON",
  RevertStateAction: "FAILURE_REVERT_STATE_ACTION"
};

function SetFailureContinuation(continuation: FailureContinuation) {
  Dispatcher.dispatch({
    type: FailureActionTypes.SetFailureContinuationAction,
    payload: continuation
  });
}

function SetFailureReason(failureReason: string) {
  Dispatcher.dispatch({
    type: FailureActionTypes.SetFailureReasonAction,
    payload: failureReason
  });
}

export function SetFailureStateAndRouteToFailure(failureArea: LogEventNames, failureReason: string, continuation: FailureContinuation, history: any) {
  LogError(failureArea, failureReason);

  // Only navigate to failure page is we aren't already there
  if (history.location.pathname != TranscriptionRoutePathNames.Failure) {
    SetFailureContinuation(continuation);
    SetFailureReason(failureReason);
    history.push(TranscriptionRoutePathNames.Failure);
  }
}

export function RevertAllStates() {
  Dispatcher.dispatch({
    type: LoadingActionTypes.RevertStateAction
  });
  Dispatcher.dispatch({
    type: TranscribingActionTypes.RevertStateAction
  });
  Dispatcher.dispatch({
    type: FailureActionTypes.RevertStateAction
  });
  Dispatcher.dispatch({
    type: RecordingActionTypes.RevertStateAction
  });
}

export async function RetryClicked(history: any) {
  try {
    LogEvents.RenderToPane.Start([{ key: RenderToPaneKeys.TriggerReason, value: "Failure page retry button clicked"}]);
    LogEvents.RenderToPane.BeginDurationMeasure(DurationMeasureType.Normal, RenderToPaneKeys.DurationSecs);

    RevertAllStates();
    history.replace(TranscriptionRoutePathNames.Loading);
  } catch(error) {
    LogEvents.RenderToPane.End([{ key: RenderToPaneKeys.RenderedSuccessfully, value: false }, { key: RenderToPaneKeys.RenderFailureReason, value: "Failure retry failed. " + ErrorStringFromException(error) }]);
    SetFailureStateAndRouteToFailure(LogEventNames.RenderToPane, TranscriptionStrings.UnknownInitFailureReason, FailureContinuation.None /*failureContinuation*/, history);
  }
};

export function RouteToFailureOnAuthPopupFailure(history: any) {
  SetFailureStateAndRouteToFailure(LogEventNames.ServiceAuthentication, TranscriptionStrings.AuthenticationLoadingFailureReason, FailureContinuation.None, history);
}

